<input
  #input
  placeHolder="Release Name"
  type="text"
  [(ngModel)]="inputValue"
  (input)="onInput()" />
